// The time zone the page shows its times in (the dashboard's and the affiliate portal's own, UTC until the person chooses): one place both
// the formatting and the date ranges read it from.
import { DEFAULT_ZONE, zoneOr } from './timezone.js';

let zone = DEFAULT_ZONE;
export const getZone = () => zone;
export const setZone = (z) => { zone = zoneOr(z); };
